module.exports = function (Utils) {
    'use strict';
    function getAllPropertiesFrom(adapter) {
        var allProperties = [];
        var obj = adapter;
        while (obj) {
            Object.getOwnPropertyNames(obj).forEach(function (p) {
                allProperties.push(p);
            });
            obj = Object.getPrototypeOf(obj);
        }
        return allProperties;
    }
    function validateAdapter(adapter) {
        var publicAdapterMethods = [
            'init',
            'destroy',
            'play',
            'pause',
            'isPlaying',
            'isSeeking',
            'getCurrentTime',
            'getDuration',
            'seek'
        ];
        var allProperties = getAllPropertiesFrom(adapter);
        publicAdapterMethods.forEach(function (method) {
            if (!allProperties.includes(method)) {
                throw new TypeError('Peaks.init(): Player method ' + method + ' is undefined');
            }
            if (typeof adapter[method] !== 'function') {
                throw new TypeError('Peaks.init(): Player method ' + method + ' is not a function');
            }
        });
    }
    function Player(peaks, adapter) {
        this._peaks = peaks;
        this._playingSegment = false;
        this._segment = null;
        this._loop = false;
        this._playSegmentTimerCallback = this._playSegmentTimerCallback.bind(this);
        validateAdapter(adapter);
        this._adapter = adapter;
        this._adapter.init(peaks);
    }
    Player.prototype.destroy = function () {
        this._adapter.destroy();
    };
    Player.prototype.play = function () {
        return this._adapter.play();
    };
    Player.prototype.pause = function () {
        this._adapter.pause();
    };
    Player.prototype.isPlaying = function () {
        return this._adapter.isPlaying();
    };
    Player.prototype.isSeeking = function () {
        return this._adapter.isSeeking();
    };
    Player.prototype.getCurrentTime = function () {
        return this._adapter.getCurrentTime();
    };
    Player.prototype.getDuration = function () {
        return this._adapter.getDuration();
    };
    Player.prototype.seek = function (time) {
        if (!Utils.isValidTime(time)) {
            this._peaks.logger('peaks.player.seek(): parameter must be a valid time, in seconds');
            return;
        }
        this._adapter.seek(time);
    };
    Player.prototype.playSegment = function (segment, loop) {
        var self = this;
        if (!segment || !Utils.isValidTime(segment.startTime) || !Utils.isValidTime(segment.endTime)) {
            self._peaks.logger('peaks.player.playSegment(): parameter must be a segment object');
            return;
        }
        self._segment = segment;
        self._loop = loop;
        self.seek(segment.startTime);
        self._peaks.once('player.playing', function () {
            if (!self._playingSegment) {
                self._playingSegment = true;
                window.requestAnimationFrame(self._playSegmentTimerCallback);
            }
        });
        self.play();
    };
    Player.prototype._playSegmentTimerCallback = function () {
        if (!this.isPlaying()) {
            this.pause();
            this._playingSegment = false;
            return;
        } else if (this.getCurrentTime() >= this._segment.endTime) {
            if (this._loop) {
                this.seek(this._segment.startTime);
            } else {
                this.pause();
                this._peaks.emit('player.ended');
                this._playingSegment = false;
                return;
            }
        }
        window.requestAnimationFrame(this._playSegmentTimerCallback);
    };
    return Player;
}(require('./utils'));